import { aiDashboardSlice } from './ai-dashboard';
import { userProfileSlice } from './user-profile';
import { riskOverTimeSlice } from '../components/assessment/risk-over-time/risk-over-time';

export const reducers = {
  userProfile: userProfileSlice.reducer,
  aiDashboard: aiDashboardSlice.reducer,
  riskOverTime: riskOverTimeSlice.reducer,
};

export const actions = {
  userProfile: userProfileSlice.actions,
  aiDashboard: aiDashboardSlice.actions,
  riskOverTime: riskOverTimeSlice.actions,
};
